module.exports = __webpack_public_path__ + "img/logo-satab.b2d763f0.png";